'use client'

import { ReactNode } from 'react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({
  size = 'md',
  className = ''
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  return (
    <div
      className={`animate-spin rounded-full border-b-2 border-primary ${sizeClasses[size]} ${className}`}
    />
  )
}

interface AuthLoadingScreenProps {
  message?: string
}

export function AuthLoadingScreen({
  message = 'Carregando...'
}: AuthLoadingScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size="lg" />
        <p className="text-sm text-white animate-pulse">{message}</p>
      </div>
    </div>
  )
}

interface PageLoadingSkeletonProps {
  children?: ReactNode
}

export function PageLoadingSkeleton({ children }: PageLoadingSkeletonProps) {
  return (
    <div className="animate-pulse">
      {children || (
        <div className="space-y-4 p-4">
          <div className="h-8 bg-muted rounded w-1/3"></div>
          <div className="space-y-2">
            <div className="h-4 bg-muted rounded w-full"></div>
            <div className="h-4 bg-muted rounded w-2/3"></div>
            <div className="h-4 bg-muted rounded w-1/2"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="h-32 bg-muted rounded"></div>
            <div className="h-32 bg-muted rounded"></div>
          </div>
        </div>
      )}
    </div>
  )
}

interface UnauthenticatedOverlayProps {
  children: ReactNode
  blur?: boolean
}

export function UnauthenticatedOverlay({
  children,
  blur = true
}: UnauthenticatedOverlayProps) {
  return (
    <div
      className={`relative ${
        blur ? 'blur-sm opacity-50' : 'opacity-75'
      } pointer-events-none select-none`}
    >
      {children}
      <div className="absolute inset-0 bg-background/10" />
    </div>
  )
}
